import { apyToApr } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const SUSDS_URL =
  'https://info-sky.blockanalitica.com/api/v1/overall/?format=json'
const sUsds = 'sUSDS::SUSDS'
const stUsds = 'Staked USDS::stUSDS'

export const susdsFetcher: YieldFetcher = {
  label: 'SUSDS',
  fetch: async () => {
    const res = await fetch(SUSDS_URL, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    }).then((r) => r.json())
    const entry = res?.[0]
    const sUsdsApr =
      apyToApr(Number(entry?.sky_savings_rate_apy ?? 0)) * 100
    // stusds_rate is already an APR in decimal form
    const stUsdsApr = Number(entry?.stusds_rate ?? 0) * 100
    return {
      [sUsds]: sUsdsApr,
      [stUsds]: stUsdsApr,
    }
  },
}
